import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { getSingleEntitySchema } from '../../application/query';
import CardsRender from './CardsRender';
import { buildPropsQuery, getGenericProps, checkPropsToUse } from '../../helpers';
import { WITH_BANNER } from '../../constants';

const CardsFactory = ({
  entity,
  entities,
  propsToDisplay,
  itemsToDisplay,
  itemListName,
  ...cardProps
}) => {
  const entityTouse = entities && entities.length ? entities[0] : entity;
  const { data, error, loading } = useQuery(getSingleEntitySchema, {
    variables: { id: entityTouse }
  });

  if (loading) return '';
  if (error) return error.message;
  if (!data) return null;

  const propsToDisplayValues = checkPropsToUse(propsToDisplay);
  const extraProps = buildPropsQuery(data, propsToDisplayValues, cardProps) || '';
  const { gridModifier, ...cardRenderProps } = getGenericProps(cardProps);
  const extraModifierForBanner = cardRenderProps.banner ? WITH_BANNER : '';

  return (
    <CardsRender
      gridModifier={`${gridModifier}${extraModifierForBanner}`}
      bannerModifier={extraModifierForBanner}
      itemsToDisplay={itemsToDisplay}
      propsToDisplay={propsToDisplay}
      entityFields={extraProps}
      {...cardRenderProps}
      entity={entityTouse}
      entities={entities}
    />
  );
};

CardsFactory.propTypes = {
  entity: PropTypes.string,
  propsToDisplay: PropTypes.array,
  itemsToDisplay: PropTypes.array,
  itemListName: PropTypes.string,
  entities: PropTypes.array
};

CardsFactory.defaultProps = {
  propsToDisplay: [],
  itemsToDisplay: [],
  itemListName: '',
  entity: null,
  entities: null
};

export default CardsFactory;
